<button mat-mini-fab color="{{iconColor}}" matTooltip="{{tooltip}}" (click)="openDialog()" *ngIf="isMiniFab">
    <mat-icon>{{icon}}</mat-icon>
</button>
<button mat-icon-button matTooltip="{{tooltip}}" (click)="openDialog()"  *ngIf="!isMiniFab">
    <mat-icon>{{icon}}</mat-icon>
</button>
